export const FEEDBACK_TYPES = [
  "Bug / Something did not work",
  "Confusing or unclear",
  "Clinical workflow feedback",
  "Public health / implementation feedback",
  "Data / privacy / interoperability feedback",
  "General suggestion",
];

export const ROLE_CONTEXTS = [
  "Patient",
  "Clinician",
  "Public health / researcher",
  "Institution / MoH",
  "Pharmacy / lab",
  "Media / reviewer",
  "Other",
];

export const FEEDBACK_AREAS = [
  "Onboarding",
  "OTP / phone verification",
  "Booking",
  "Payments",
  "Messages / Fola",
  "myEHR / records",
  "VitalRep™ / clinician notes",
  "Referrals",
  "General platform",
];

export const SEVERITIES = ["Low", "Medium", "High", "Blocking"];

export function normalizeFeedbackSeverity(value = "Medium") {
  const clean = String(value || "").trim().toLowerCase();
  return SEVERITIES.find((item) => item.toLowerCase() === clean) || "Medium";
}
